export default __webpack_public_path__ + "static/media/03.ef33801b.png";